module.exports = __webpack_public_path__ + "img/186.181bfd4a.jpg";